import { AddressType, ThirdPartyNames } from 'src/app/_common/_enum/module.enum';

export class BasicInfo {
    constructor(
        public accountName: string = '',
        public accountDBAName: string = '',
        public accountLegalEntity: string = '',
        public accountFein: string = '',
        public accountWebsite: string = '',
        public accountPhoneNumber: string = '',
        public accountIndicator: number = null,
        public isMailingSameAsInsured: boolean = false,
        public isBillingSameAsMailing: boolean = false,

        public addresses: [
            BusinessAddress,
            MailingAddress,
            BillingAddress
        ],

        public primaryContactNotProvided: boolean = true,
        public contact: { },
        public glKickoutWOS: boolean = true
    ) {}
}

export class Application {
    constructor(
        public questionAnswers: any
    ) {}
}

export class Coverages {
    constructor(
    ) {}
}

export class DiceQuote {
    constructor(
        public thirdPartyName: string = ThirdPartyNames.DNB,
        public thirdPartyKey: string = "",
        public searchState: string = "",
        public accountKey: string = "",
        public accountNumber: number,
        public accountName: string,
        public accountDBAName: string,
        public accountLegalEntity: string = '',
        public accountFein: string,
        public accountWebsite: string,
        public accountPhoneNumber: string = '',
        public accountIndicator: number,
        public isMailingSameAsInsured: boolean,
        public isMailingOrBillingSameAsInsured: number = 0, //0 = both are same as insured, 1 = mailing same as insured, 2 = billing same as mailing, 3 = mailing and billing both are different

        public addresses: any,

        public primaryContactNotProvided: boolean = true,
        public contact: { },

        public questionAnswers: [
            { questionID: string, fullText: string, answer: string, additionalInfo: any, shortText: string, name: string, sectionID: string }
        ],

        public coverage: { policyEffectiveDate: string, annualGPC: string, yearGPC: string, mediaTypes: any, loBs: any },

        public attachments: [],
        public acceptAcknowledgement:boolean = false,

        public glKickoutWOS: boolean = true
    ){}
}

export class DiceQuoteForm {
    thirdPartyName: string = ThirdPartyNames.DNB;
    thirdPartyKey: string = "";
    accountKey: string = "";
    accountNumber: number = 0;
    accountName: string = '';
    accountDBAName: string = '';
    accountLegalEntity: string = '';
    accountFein: string = null;
    thirdPartyFEIN: string = null;
    accountWebsite: string = '';
    accountPhoneNumber: string = '';
    accountIndicator: number = 0
    isMailingSameAsInsured: boolean = false;
    isBillingSameAsMailing: boolean = false;
    isMailingOrBillingSameAsInsured: number = 0; //0 = both are same as insured, 1 = mailing same as insured, 2 = billing same as mailing, 3 = mailing and billing both are different
    searchState: string = '';

    addresses:any = [
        new BusinessAddress(),
        new MailingAddress(),
        new BillingAddress()
     ];

    primaryContactNotProvided: boolean = true;
    contact:any = new ContactObject();

    questionAnswers:any = [];

    coverage: any = new Coverage();

    attachments:any = [];

    acceptAcknowledgement:boolean = false;

    producerCode: number = null;
    producerName: string = '';
    producerCity: string = '';
    producerState: string = '';

    glKickoutWOS: boolean = true;
}

export class Coverage {
    policyEffectiveDate: any = null;
    annualGPC: any = '';
    yearGPC: any = '';
    mediaTypes: any = [];
    loBs: any = [];
};

export class ContactObject{
    firstName:string = null;
    lastName:string = null;
    roleName: string = null;
    email: string = null;
    phone: string = null;
}

export class PrimaryContact extends ContactObject {
    roleName: string = 'Primary';
}

export class AuditContact extends ContactObject {
    roleName: string = 'Audit';
}

export class BillingContact extends ContactObject {
    roleName: string = 'Billing';
}

export class LocationObject {
    addressType : string = "";
    careof: string = "";
    addressLine1: string = "";
    addressLine2: string = "";
    city: string = "";
    state: string = "";
    zip: string = "";
    country: string = "";
    county: string = "";
    verified: string = "";
}

export class BusinessAddress extends LocationObject{
    addressType : string = AddressType.Business;
}
export class MailingAddress extends LocationObject{
    addressType : string = AddressType.Mailing;
}
export class BillingAddress extends LocationObject{
    addressType : string = AddressType.Billing;
}

export class BindQuote {
    applicationId: string = null;
    quoteId: string = null;
    accountName: string = null;
    policyEffectiveDate: any = null;
    billingType: string = null;
    paymentPlan : string = '';
    contacts: any = [];
    waiveTRIA: boolean = false;    
    certifyWaiveTRIA: boolean = false;
    accountFein: string = null;
    certifyWaiveWC: boolean;
    lobBindQA: any = null;
    workerOptions: any = null;
    attachments: any = [];
}

export const Billing = [
    {
        id: 'Direct',
        text: 'Direct Bill',
        isSelected: false
    },
    {
        id: 'Agency',
        text: 'Agency Bill',
        isSelected: false
    }
]

export const DiceContacts = [
    {
        sectionTitle: 'Audit Contact',
        sectionMoreInfo: 'Required for all accounts.',
        detail: {
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            role: 'Audit'
        }
    },
    {
        sectionTitle: 'Billing Contact',
        sectionMoreInfo: 'This is optional, but recommended for Direct Bill accounts.',
        detail: {
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            role: 'Billing'
        }
    }
]

export class CopyQuote {
    applicationId: string = null;
    accountFein: string = null;
    attachments: any = [];
    quoteId: string = null;
    policyEffectiveDate: string = null;
    annualGPC: any = null;
    yearGPC: any = null;
    mediaTypes: any = [];
    loBs: any = null
}

export class DiceQuoteMethod{
    getBusinessAddress(_diceQuoteForm: DiceQuoteForm){
        return _diceQuoteForm.addresses[0];
    }
    
    getMailingAddress(_diceQuoteForm:DiceQuoteForm){
        if(!_diceQuoteForm.isMailingSameAsInsured && _diceQuoteForm.addresses.length > 1)
            return _diceQuoteForm.addresses.find(_address=> {return _address.addressType === AddressType.Mailing});
        else
            return null;
    }
    
    getBillingAddress(_diceQuoteForm:DiceQuoteForm){
        if(!_diceQuoteForm.isBillingSameAsMailing && _diceQuoteForm.addresses.length > 1)
            return _diceQuoteForm.addresses.find(_address=> {return _address.addressType === AddressType.Billing});
        else
            return null;
    }
}